var _excluded = ["children"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { node } from 'prop-types';
var StyledLegend = styled.legend(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 0;\n  max-width: 0;\n  width: auto;\n  height: 0;\n  font-weight: normal;\n  visibility: hidden;\n  transition-property: max-width, padding;\n\n  ", "\n"])), function (_ref) {
  var input = _ref.theme.yoga.components.input;
  return "\n    font-size: " + input.label.font.size.typed + "px;\n    letter-spacing: normal;\n\n    transition-duration: 100ms;\n  ";
});
var HiddenSpan = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var input = _ref2.theme.yoga.components.input;
  return "\n    padding-left: " + input.label.padding.left + "px;\n    padding-right: " + input.label.padding.right + "px;\n  ";
});
var Legend = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(StyledLegend, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(HiddenSpan, null, children));
});
Legend.propTypes = {
  children: node.isRequired
};
export default Legend;